import React from 'react'
import styled from '@emotion/styled'
import { fontSize, spacing } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/account-management/utils/domain/intl'

const StyledContainer = styled.div({
  flex: 1,
  alignSelf: 'center',

  textAlign: 'center',
  '.header': {
    fontSize: fontSize.X18,
    marginBottom: spacing.X20,
  },
  '.prompt': {
    fontSize: fontSize.X15,
    marginBottom: spacing.X20,
  },
  '.button': {
    textTransform: 'uppercase',
  },
})

interface Props {}

export const ListAccountsNoResults: React.FunctionComponent<Props> = ({ ...props }) => {
  const { header, prompt } = useDomainMessages({
    header: 'accountManagementDomain.list.noResults.header',
    prompt: 'accountManagementDomain.list.noResults.prompt',
  })

  return (
    <StyledContainer data-testid={props['data-testid']}>
      <div className="header">{header}</div>
      <div className="prompt">{prompt}</div>
    </StyledContainer>
  )
}
